import React from "react";
import { arrayOf, number, shape, string } from "prop-types";
import { Card } from "uikit/components";
import styles from "./MunicipalityTrainingPlansView.module.styl";
import MunicipalityTrainingPlansRow from "components/municipalitySummary/MunicipalityTrainingPlansRow/MunicipalityTrainingPlansRow";

export default function MunicipalityTrainingPlansView({ municipalityId, schoolTrainingPlans }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <div
                className={styles.headingContainer}
                data-test-name="municipality_training_plans_form"
            >
                <div className={styles.schoolName}>Название организации</div>
                <div className={styles.trainingPlanFilling}>Наполнение</div>
            </div>
            <div>
                {schoolTrainingPlans?.map((item) => (
                    <MunicipalityTrainingPlansRow
                        key={item.schoolId}
                        schoolTrainingPlan={item}
                        municipalityId={municipalityId}
                    />
                )) ?? []}
            </div>
        </Card>
    );
}

MunicipalityTrainingPlansView.propTypes = {
    municipalityId: number.isRequired,
    schoolTrainingPlans: arrayOf(
        shape({
            schoolId: number.isRequired,
            schoolName: string.isRequired,
            trainingPlanFilling: number.isRequired,
        }),
    ),
};
